import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ApproveItemModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ApproveItemModalContainer" */
      './ApproveItemModalContainer'
    ),
  loading: LoadingModal,
});
